import instance from '@/api/instance'

export default {
  getArticleSite: () => {
    return instance.get('/news')
  },
}
